// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CategorySegmentsColumn_wrapper__1kdAO","inDesktop":"CategorySegmentsColumn_inDesktop__1i3g6"};